import * as types from './types'

// InitialState
const initialState = {
  championship: null,
  pending: false,
  error: null,

  createChampionshipError: null,
  createChampionshipPending: false,

  updateChampionshipError: null,
  updateChampionshipPending: false,

  reactPending: false,
  reactError: null,

  settingImage: false,
  deleteImagePending: false,

  championshipResults: null,
  championshipResultsPending: false,

  eventCircuitCategoryResults: {},
  eventCircuitCategoryResultsPending: false,
  eventCircuitCategoryResultsError: null
}

// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.LOAD_CHAMPIONSHIP_ATTEMPT:
      return {
        ...state,
        championship: null,
        error: null,
        pending: true
      }
    case types.LOAD_CHAMPIONSHIP_SUCCESS:
      return {
        ...state,
        championship: action.championship,
        pending: false
      }
    case types.LOAD_CHAMPIONSHIP_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error
      }

    case types.CREATE_CHAMPIONSHIP_ATTEMPT:
      return {
        ...state,
        createChampionshipError: null,
        createChampionshipPending: true
      }
    case types.CREATE_CHAMPIONSHIP_SUCCESS:
      return {
        ...state,
        createChampionshipPending: false
      }
    case types.CREATE_CHAMPIONSHIP_FAILURE:
      return {
        ...state,
        createChampionshipPending: false,
        createChampionshipError: action.error
      }

    case types.UPDATE_CHAMPIONSHIP_ATTEMPT:
      return {
        ...state,
        updateChampionshipError: null,
        updateChampionshipPending: true
      }
    case types.UPDATE_CHAMPIONSHIP_SUCCESS:
      return {
        ...state,
        updateChampionshipPending: false
      }
    case types.UPDATE_CHAMPIONSHIP_FAILURE:
      return {
        ...state,
        updateChampionshipPending: false,
        updateChampionshipError: action.error
      }

    case types.REACT_ATTEMPT:
      return {
        ...state,
        reactPending: true,
        reactError: null
      }

    case types.REACT_SUCCESS:
      return {
        ...state,
        reactPending: false,
        championship: action.championship
      }

    case types.REACT_FAILURE:
      return {
        ...state,
        reactPending: false,
        reactError: action.error
      }

    case types.SET_IMAGE_ATTEMPT:
      return {
        ...state,
        pending: true,
        error: null,
        settingImage: true
      }
    case types.SET_IMAGE_SUCCESS:
      return {
        ...state,
        settingImage: false,
        pending: false,
        championship: action.championship
      }
    case types.SET_IMAGE_FAILURE:
      return {
        ...state,
        pending: false,
        settingImage: false,
        error: action.error
      }
    case types.DELETE_IMAGE_ATTEMPT:
      return {
        ...state,
        deleteImagePending: true
      }
    case types.DELETE_IMAGE_SUCCESS:
      return {
        ...state,
        championship: action.championship,
        deleteImagePending: false
      }
    case types.DELETE_IMAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        deleteImagePending: false
      }

    case types.LOAD_RESULTS_ATTEMPT:
      return {
        ...state,
        championshipResults: null,
        championshipResultsPending: true
      }

    case types.LOAD_RESULTS_SUCCESS:
      return {
        ...state,
        championshipResults: action.results,
        championshipResultsPending: false
      }

    case types.LOAD_RESULTS_FAILURE:
      return {
        ...state,
        championshipResultsPending: false
      }

    case types.LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_ATTEMPT:
      return {
        ...state,
        eventCircuitCategoryResultsPending: true,
        eventCircuitCategoryResultsError: null
      }

    case types.LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_SUCCESS:
      return {
        ...state,
        eventCircuitCategoryResults: action.eventCircuitCategoryResults,
        eventCircuitCategoryResultsPending: false
      }
    case types.LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_FAILURE:
      return {
        ...state,
        eventCircuitCategoryResultsError: action.error,
        eventCircuitCategoryResultsPending: false
      }
    default:
      return state
  }
}
